// @flow

import React from 'react';
import { connect } from 'react-redux';
import type { MediaGallery } from '../../../types/keepeekType';
import { BEST_OF, getMediaByGallery } from '../../../utils/keepeekUtils';

type Props = {
  officesMedias: MediaGallery[],
  selectedBuildingId: string,
}

type State = {
  scaleFactor: number,
}

class Intro extends React.PureComponent<Props, State> {
  render() {
    if (!this.props.selectedBuildingId) {
      return false;
    }
    const buildingMedias = this.props.officesMedias.filter(
      buildingMedia => !this.props.selectedBuildingId || buildingMedia.buildingId.toString() === this.props.selectedBuildingId
    )[0]
    if (!buildingMedias) {
      return false;
    }
    const headerImg = getMediaByGallery(buildingMedias.galleries, BEST_OF);
    return (
      headerImg[0] ?
        <div className="best-of-image-container">
          <img
            alt="Best of"
            className="best-of-image"
            src={headerImg[0].fullscreen}
          />
        </div>
        : null
    );
  }
}

export default connect(state => ({
  officesMedias: state.office.officesMedias,
}))(Intro);
